var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rank",class:{'is-loading': _vm.loading}},[_c('div',{staticClass:"rank-bands"},[_c('core-simplebar',{staticClass:"rank-bands-scroll"},[_vm._t("bands")],2)],1),_c('div',{staticClass:"rank-games"},[_vm._t("games")],2),_c('div',{staticClass:"rank-metrics"},[_vm._t("metrics")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }